// src/services/recipesAPI.js
import axios from "axios";

// This should resolve to:  <API_BASE>/admin/recipes
const BASE_URL = process.env.REACT_APP_BASE_URL + "/recipes";

const setTokenAllHeaders = async () => {
    const token = localStorage.getItem("adminToken");
    axios.defaults.headers.common["Authorization"] = token;
};

/**
 * List recipes with pagination + quick search + status filter
 * Maps to: GET /admin/recipes
 */
const getAllRecipes = async ({
    limit = 15,
    page = 0,
    status = null,
    sortModel = [],
    filterModel = [],
}) => {
    try {
        await setTokenAllHeaders();

        let sendStatus = status;
        if (sendStatus === 0) sendStatus = null;

        let search = null;
        if (filterModel["quickFilterValues"]) {
            search = filterModel["quickFilterValues"][0] || null;
        }

        const response = await axios.get(BASE_URL, {
            params: {   
                limit,
                page,
                status: sendStatus,
                search,
                sort: sortModel, // backend can parse same way as products
            },
        });

        return response.data;
    } catch (error) {
        console.error("Error fetching recipes:", error);
        throw error;
    }
};

/**
 * Get single recipe (for edit / view)
 * Maps to: GET /admin/recipes/:id
 */
const getRecipeDetail = async (recipeId) => {
    try {
        await setTokenAllHeaders();
        const response = await axios.get(`${BASE_URL}/${recipeId}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching recipe detail:", error);
        throw error;
    }
};

/**
 * Create or update recipe with multipart/form-data
 * - If recipeId is present -> UPDATE (PUT /recipes/:id)
 * - Else -> CREATE (POST /recipes)
 *
 * formData must contain:
 *   - payload: JSON.stringify({...})
 *   - mediaFiles[index]: File
 */
const saveRecipe = async (formData, recipeId = null) => {
  try {
    await setTokenAllHeaders();

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    let response;
    if (recipeId) {
      // EDIT mode
      response = await axios.post(`${BASE_URL}/${recipeId}`, formData, config);
    } else {
      // CREATE mode
      response = await axios.post(BASE_URL, formData, config);
    }

    return response.data;
  } catch (error) {
    console.error("Error saving recipe:", error);
    throw error;
  }
};

// rest stays same
const updateRecipeStatus = async ({ recipeId, status, reason = null }) => {
    try {
        await setTokenAllHeaders();
        const response = await axios.patch(`${BASE_URL}/${recipeId}/status`, {
            isActive: status,
            reason,
        });
        return response.data;
    } catch (error) {
        console.error("Error updating recipe status:", error);
        throw error;
    }
};

const deleteRecipe = async (recipeId) => {
    try {
        await setTokenAllHeaders();
        const response = await axios.delete(`${BASE_URL}/${recipeId}`);
        return response.data;
    } catch (error) {
        console.error("Error deleting recipe:", error);
        throw error;
    }
};

const recipesAPI = {
    getAllRecipes,
    getRecipeDetail,
    saveRecipe,
    updateRecipeStatus,
    deleteRecipe,
};

export default recipesAPI;
